import { Section } from "../components/sections/TextSection";

export const LineConfig: Section = {
    row: 0,
    col: 0,
    name: 'Line',
    type: 'line',
    id: '33333',
    selected: false,
    height: 60,
    width: 60,
    rowCount: 10,
    colCount: 10,
    textContent: "",
    x: 0,
    y: 0,
    isLocked: false,
    propInfo: [
        {
            name: "LineType",
            inputType: 'dropdown',
            options: [
                { label: 'Horizontal', value: 'horizontal' },
                { label: 'Vertical', value: 'vertical' },
                { label: 'Diagonal', value: 'diagonal' },
            ],
            binding: 'dataset.lineType',
            value: 'horizontal',
            label: 'Line Style',
        },
        {
            name: "strokeColor",
            inputType: 'color',
            binding: 'attributes.stroke.value',
            value: '#000000',
            label: 'Line Color',
        },
        {
            name: "strokeWidth",
            binding: 'attributes.stroke-width.value',
            inputType: 'number',
            value: '2',
            label: 'Line Width',
        },
        {
            name:'fillType',
            inputType:'dropdown',
            options:[
                {label:'Solid',value:'0,0'},
                {label:'Dotted',value:'1,5'},
                {label:'Dashed',value:'10,5'},
            ],
            binding:'attributes.stroke-dasharray.value',
            value:'0,0',
            label:'Border Type',
        }       
    ]
};
